module.exports = __webpack_public_path__ + "static/media/snipe nite.de4cd691.png";